/** Decimal places a control's step can express: 0.05 -> 2, 1 -> 0. */
export function getStepPrecision(step) {
  if (!Number.isFinite(step) || step <= 0) return 0;
  const text = String(step);
  if (text.includes('e-')) return Number(text.split('e-')[1]) || 0;
  return text.includes('.') ? text.split('.')[1].length : 0;
}

/**
 * A number in the precision its control's step can express, for DISPLAY. Interpolation and
 * float arithmetic produce values like 1.0566 or 0.7875000000000001 that no step can reach;
 * shown raw they read as noise. Stored values keep full precision; this only shapes text.
 */
export function formatToStepPrecision(value, step) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return value;
  if (!Number.isFinite(step) || step <= 0) return value;
  return Number(value.toFixed(getStepPrecision(step)));
}
